import axios from 'axios';
import AlertBox from 'blocks/AlertBox';
import Button, { ButtonWrapper } from 'blocks/Button';
import Input from 'blocks/Input';
import BaseModal from 'components/modals/BaseModal';
import { useForm } from 'hooks/useForm';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import urls from 'utils/urls';
import { ContentProps } from './forgetPassword.interface';
import * as S from './forgetPasswordModal.styles';

const Content = ({ open, closeModal }: ContentProps) => {
  const { t } = useTranslation('');
  const [step, setStep] = useState<number>(1);
  const [loading, setLoading] = useState(false);

  const { inputFields, handleChange, resetInputFields } = useForm({
    email: {
      name: 'email',
      type: 'text',
      value: '',
    },
  });

  useEffect((): void => {
    if (!open) resetInputFields();
  }, [open]);

  const sendEmail = async () => {
    setLoading(true);

    await axios
      .post(
        urls.forgotPassword,

        {
          email: inputFields.email.value,
        }
      )
      .then((res) => {
        setStep(2);
      })
      .catch((ex) => {
        toast.error(ex?.response?.data?.message);
      })
      .finally(() => setLoading(false));
  };

  return (
    <S.ForgetPasswordModal>
      {step === 1 && (
        <>
          <S.ForgetPasswordTextBold>{t('modals.forgotPassword.title')}</S.ForgetPasswordTextBold>
          <S.ForgetPasswordModalText>{t('modals.forgotPassword.description')}</S.ForgetPasswordModalText>
          <Input
            inputField={{ ...inputFields.email, label: t('modals.forgotPassword.form.fields.email.label') }}
            onChange={handleChange}
          />

          <S.ButtonWrapper as={ButtonWrapper}>
            <Button onClick={closeModal} width={134} color="outlined">
              {t('modals.forgotPassword.form.cancelCTA')}
            </Button>
            <Button loading={loading} onClick={sendEmail} width={134}>
              {t('modals.forgotPassword.form.submitCTA')}
            </Button>
          </S.ButtonWrapper>
        </>
      )}

      {step === 2 && (
        <>
          <AlertBox type="success" text={t('modals.forgotPassword.successMessage.title')} />

          <S.Divider></S.Divider>

          <S.Text>
            {t('modals.forgotPassword.successMessage.description0')} <br /> <br />
            {t('modals.forgotPassword.successMessage.description1')} <br />
            {t('modals.forgotPassword.successMessage.description2')}
          </S.Text>

          <S.Buttons>
            <S.Button onClick={closeModal}>{t('modals.forgotPassword.successMessage.closeCTA')}</S.Button>
          </S.Buttons>
        </>
      )}
    </S.ForgetPasswordModal>
  );
};

interface State {
  open: boolean;
}

interface Props {
  ref: any;
}

class ForgetPasswordModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  openModal = (): void => this.setState({ open: true });

  closeModal = (): void => this.setState({ open: false });

  render() {
    return (
      <S.ForgetPasswordModalContainer as={BaseModal} open={this.state.open} closeModal={this.closeModal}>
        <Content {...this.props} open={this.state.open} closeModal={this.closeModal} />
      </S.ForgetPasswordModalContainer>
    );
  }
}

export default ForgetPasswordModal;
